import { render } from "./CustomizeSelectPostDialog.vue?vue&type=template&id=7319bc92"
import script from "./CustomizeSelectPostDialog.vue?vue&type=script&lang=js"
export * from "./CustomizeSelectPostDialog.vue?vue&type=script&lang=js"

import "./CustomizeSelectPostDialog.vue?vue&type=style&index=0&id=7319bc92&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__